var map = {
	"./decidim/avatar-multiuser.png": 13450,
	"./decidim/brands/google.svg": 12677,
	"./decidim/cc-badge.png": 5076,
	"./decidim/decidim-logo.svg": 23896,
	"./decidim/default-avatar.svg": 77472,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 26300,
	"./decidim/icons.svg": 82235,
	"./decidim/pattern.png": 37116,
	"./decidim/placeholder-card-g.svg": 59033,
	"./decidim/placeholder-card-l.svg": 70930,
	"./decidim/placeholder.jpg": 87889,
	"./decidim/remixicon.symbol.svg": 52213,
	"./decidim/vendor/leaflet/layers-2x.png": 11476,
	"./decidim/vendor/leaflet/layers.png": 17747,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 97710,
	"./decidim/vendor/leaflet/marker-icon.png": 46133,
	"./decidim/vendor/leaflet/marker-shadow.png": 4314,
	"./decidim/vendor/social-share-button/douban.svg": 49124,
	"./decidim/vendor/social-share-button/email.svg": 43329,
	"./decidim/vendor/social-share-button/facebook.svg": 77255,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 68601,
	"./decidim/vendor/social-share-button/hacker_news.svg": 66385,
	"./decidim/vendor/social-share-button/linkedin.svg": 82817,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 53826,
	"./decidim/vendor/social-share-button/pinterest.svg": 23351,
	"./decidim/vendor/social-share-button/reddit.svg": 23771,
	"./decidim/vendor/social-share-button/telegram.svg": 41758,
	"./decidim/vendor/social-share-button/tumblr.svg": 81821,
	"./decidim/vendor/social-share-button/twitter.svg": 56387,
	"./decidim/vendor/social-share-button/vkontakte.svg": 95230,
	"./decidim/vendor/social-share-button/wechat.svg": 58265,
	"./decidim/vendor/social-share-button/whatsapp.svg": 26977,
	"./decidim/vendor/social-share-button/x.svg": 49961,
	"./decidim/vendor/social-share-button/xing.svg": 68583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1529;